var React = require('react');

function Mouse (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_36","data-name":"Group 36","transform":"translate(-951.5 -996.5)"},React.createElement("g",{"id":"Group_35","data-name":"Group 35","transform":"translate(952 997)"},[React.createElement("path",{"id":"Path_1663","data-name":"Path 1663","d":"M739.958,369.979v15.988a3.97,3.97,0,0,1-3.97,3.97H723.97a3.97,3.97,0,0,1-3.97-3.97V369.979a9.979,9.979,0,0,1,19.958,0Z","transform":"translate(-720 -360)","fill":"none","stroke":"#14171c","strokeMiterlimit":"10","strokeWidth":"1","key":0}),React.createElement("line",{"id":"Line_21","data-name":"Line 21","y2":"10","transform":"translate(9.979 4.969)","fill":"none","stroke":"#14171c","strokeMiterlimit":"10","strokeWidth":"1","key":1})])));
}

Mouse.defaultProps = {"width":"20.958","height":"30.938","viewBox":"0 0 20.958 30.938"};

module.exports = Mouse;

Mouse.default = Mouse;
